
import { Component, Vue } from "vue-property-decorator";
import { ScanforAcceptPacketModule } from "@/store/modules/store_scanforacceptpacket";
import dayjs from "dayjs";
import { cloudPressForSortingGataWay} from "@/api/service";
import { SystemConfigModule } from "@/store/modules/store_systemconfig";

@Component({
  name: "Form2",
})
export default class extends Vue {
  //   @Watch("formmodel2", { deep: true })
  //   onChildChanged(val: string) {
  //     this.$emit("get-form2-value", val);
  //   }
  get NeedWeightFlag() {
    return ScanforAcceptPacketModule.checked_NeedWeight;
  }
  set NeedWeightFlag(state) {
    ScanforAcceptPacketModule.NeedWeightChangeState(state);
    // ScanforGetOnModule.AutoCreateCarCodeChangeState(true);
  }
  get VoiceFlag() {
    return ScanforAcceptPacketModule.checked_Voice;
  }
  set VoiceFlag(state) {
    ScanforAcceptPacketModule.VoiceChangeState(state);
    // ScanforGetOnModule.AutoCreateCarCodeChangeState(true);
  }

  get GetOrderDestnationOrgFlag() {
    return ScanforAcceptPacketModule.checked_GetOrderDestnationOrg;
  }
  set GetOrderDestnationOrgFlag(state) {
    ScanforAcceptPacketModule.GetOrderDestnationOrgChangeState(state);
    // ScanforGetOnModule.AutoCreateCarCodeChangeState(true);
  }

  get OverWeightPromotFlag() {
    return ScanforAcceptPacketModule.checked_OverWeightPromot;
  }
  set OverWeightPromotFlag(state) {
    ScanforAcceptPacketModule.OverWeightPromotChangeState(state);
    // ScanforGetOnModule.AutoCreateCarCodeChangeState(true);
  }

  public OverWeightPromotShow = true;

  public CheckReCodeShow = false;
  public globalConfig: any = {};
  //   public systemConfig: any = {};
  //   public loginData: any = {};

  mounted() {
    this.globalConfig = SystemConfigModule.globalData;
    this.loginData = SystemConfigModule.loginData;
    this.GetOverWeightPromotCheckBoxVisibleFunc();
    ScanforAcceptPacketModule.GetOrderDestnationOrgChangeState(true);
    ScanforAcceptPacketModule.NeedWeightChangeState(true);
    ScanforAcceptPacketModule.OverWeightPromotChangeState(false);
    ScanforAcceptPacketModule.VoiceChangeState(false);
    this.GetInOutFlagFromLitticePlan();
  }

  public loginData: any = {};

  public GetOverWeightPromotCheckBoxVisibleFunc() {
    if (typeof obj_HttpRequest_Core != "undefined") {
      if (
        this.globalConfig.CurrentDeviceType == 1 ||
        this.globalConfig.CurrentDeviceType == 6
      ) {
        this.OverWeightPromotShow = true;
      } else {
        this.OverWeightPromotShow = false;
      }
    }
  }

  //获取格口方案中的进出港标识
  private GetInOutFlagFromLitticePlan()
  {
    debugger;
    try {
      let datetimeNow = dayjs().format("YYYY-MM-DD HH:mm:ss.SSS");
      let signsure = obj_HttpRequest_Core.getSignature("8600", datetimeNow);

      let _request = {
        mty: "8600",
        signature: signsure, //登录时需要获取的签名
        createTime: datetimeNow,
        txId: "",
        extend1: this.loginData.userCode,
        extend2: "",
        extend3: "",
      };
      let stReturnStr = JSON.parse(cloudPressForSortingGataWay(JSON.stringify(_request)));
      console.log("14888");
      console.log(stReturnStr);
      if (stReturnStr?.code == "000") {
        let temp:any = stReturnStr.data.latticeSchemeList;
        for (var i in temp)
        {
          if (temp[i].status == "1" && temp[i].inOutFlag == "CG")
          {
              this.CheckReCodeShow = true;
          }
        }
      }
      else
      {
        console.log("获取格口方案中进出港标识失败：" + stReturnStr.code);
      }
    }
    catch (e) {
      console.log("获取格口方案中进出港标识失败：" + e);
    }
  }

  //   private formmodel2 = {
  //     checked_OverWeightPromot: false,
  //     checked_GetOrderDestnationOrg: true,
  //     checked_Voice: false,
  //     checked_NeedWeight: true,
  //   };
}
